export const organization = {
  routes: [
    {
      path: "/organization/question-set-survey",
      component: () => import("../organization-question-set-and-survey"),
    },
  ],
};
export const gdpr = {
  routes: [
    {
      path: "/gdpr/question-set-survey",
      component: () => import("../organization-question-set-and-survey"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/question-set-survey",
      component: () => import("../organization-question-set-and-survey"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/question-set-survey",
      component: () => import("../organization-question-set-and-survey"),
    },
  ],
};

export const bgys = {
  routes: [
    {
      path: "/bgys/question-set-survey",
      component: () => import("../organization-question-set-and-survey"),
    },
  ],
};
